import React from 'react';
import PropTypes from 'prop-types';

import { Alert, Form } from 'react-bootstrap-5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFlask } from '@fortawesome/pro-solid-svg-icons';

import ManagedInput from 'components/form/managed_input';

export function ShadowCreationOrImportModalBody({ grid, grids, mode, onGridChange, onModeChange }) {
  return (
    <Form className="d-flex flex-column gap-3">
      <label>Chose one to create a grid template</label>

      <Form.Check
        checked={mode === 'create'}
        id="template"
        label="Create from a grid template, or start fresh with a blank grid"
        type="radio"
        onChange={() => onModeChange('create')}
      />

      {mode === 'create' && (
        <ManagedInput
          getOptionLabel={grid => grid.name}
          getOptionValue={grid => grid.id}
          options={grids}
          type="combobox"
          value={grid}
          onValueChange={onGridChange}
        />
      )}

      <Form.Check
        checked={mode === 'import'}
        id="import"
        label="Create from an uploaded Excel spreadsheet"
        type="radio"
        onChange={() => onModeChange('import')}
      />

      {mode === 'import' && (
        <Alert variant="warning">
          <div className="d-flex gap-2">
            <FontAwesomeIcon icon={faFlask}/>
            <div>
              <strong>This feature is experimental</strong>
              <div>
                Some formulas, data attributes, and formatting elements may not be preserved in the
                imported grid
              </div>
            </div>
          </div>
        </Alert>
      )}
    </Form>
  );
}

ShadowCreationOrImportModalBody.propTypes = {
  grid: PropTypes.object,
  grids: PropTypes.array.isRequired,
  mode: PropTypes.string,
  onGridChange: PropTypes.func.isRequired,
  onModeChange: PropTypes.func.isRequired,
};

export default ShadowCreationOrImportModalBody;
